import {useRegionConfig} from '@frontend/hooks/useRegionConfig'
import type {ReactNode} from 'react'
import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'
import type {RegionCode} from '../../types'

interface Props extends AnyObject<ReactNode | (() => (ReactNode | ReactNode[])), RegionCode> {
    default?: ReactNode | (() => (ReactNode | ReactNode[]))
}

// Отображает компонент соответствующий текущей локали приложения или компонент "по умолчанию".
export function LocaleComponentPicker(props: Props) {

    const regionConfig = useRegionConfig()
    const content = props[regionConfig.region] ?? props.default

    return (
        <>
            {typeof content === 'function' ? content() : content}
        </>
    )
}
